import React from 'react';

export class Salus extends React.Component {
  render(){
      return (
        <div className="w3-card w3-animate-bottom full-project-card" id="salus">
          <h1>Salus</h1>
          <p>SALUS CORNELL ANIMAL HEALTH HACKATHON 2017</p>
          
          <h2>Description</h2>
          <p>The protein count in cat urine can be a symptom of serious kidney disease. Dipsticks can be used to determine how much protein is in cat urine. This dipstick reader will be able to be put inside of a litter box to be able to alert the owner of a cat's sickness before other symptoms can be seen.</p>

          <div className="video-container">
            <iframe className="video" src="https://www.youtube.com/embed/_3n-KGlGHTw" title="SalusVideo" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>
        </div>
    );
  }
}
